import { isSubscriptionPastDue } from './isSubscriptionPastDue';

interface CancelableSubscription {
  cancellation_at?: string | null;
  past_due?: boolean | null;
  plan?: { slug?: string | null; value?: number | string | null } | null;
}

/**
 * A Pagarme grace deadline is stored in cancellation_at while past_due is
 * true. That is still a recoverable subscription, not a cancellation.
 */
export function isCanceledSubscription(
  subscription: CancelableSubscription | null | undefined,
): boolean {
  return Boolean(subscription?.cancellation_at) && !isSubscriptionPastDue(subscription);
}
